import React, { lazy, Suspense } from "react";
import PortfolioStory, { InfoPage, WorkPage } from "./components/Studio/StudioPortfolio";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { ProjectDemo, ProjectDetail, ProjectsIndex } from "./components/Projects/ProjectPages";

const Resume = lazy(() => import("./components/Story/ResumeStory"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="story story-route-loading" role="status">
            Opening the next page…
          </div>
        }
      >
        <Routes>
          <Route element={<PortfolioStory />}>
            <Route path="/" element={<WorkPage />} />
            <Route path="/info" element={<InfoPage />} />
            <Route path="/projects" element={<ProjectsIndex />} />
            <Route path="/projects/:slug/demo" element={<ProjectDemo />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
          </Route>
          <Route path="/resume" element={<Resume />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
